module.exports = __webpack_public_path__ + "static/istock-918746438-compressor-7ae63360af116f795aaa0c1801cd7945.jpg";